import { fromFetch } from 'rxjs/fetch';

import { AuthHeaders } from '../../../models/auth-headers';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { UserPagedCollectionParams } from '../../../models/user-paged-collection-params';
import { createPagedCollectionSchema } from '../../../utils/create-paged-collection-schema';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { fleetUserSchema } from '../schemas/fleet-user.schema';

/**
 * Get a paginated list of all users given a list of asset IDs (a.k.a., external IDs)
 * including fleet info
 *
 * Use case: The user imports a list of asset IDs to use as a filter on list of assets
 * in the data table.
 *
 * @param params User Paged Collection Params
 * @param assetIds List of asset IDs
 * @returns Paged Collection of Users
 */
export function postUsersFleetInfo(
  this: unknown,
  params: UserPagedCollectionParams,
  assetIds: string[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).usersFleetInfoAllUrl}?${params.urlParams}`,
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
              ? new AuthHeaders()
              : jwtAuthHeaders),
          },
          body: JSON.stringify({
            assetIds,
          }),
        }
      )
    )
  ).pipe(selectData(createPagedCollectionSchema(fleetUserSchema)));
}
